"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabNav = exports.TabNavItem = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TabNavItem = function TabNavItem(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      classNames = _ref.classNames,
      disabled = _ref.disabled,
      selected = _ref.selected,
      onClick = _ref.onClick,
      NewProps = _objectWithoutProperties(_ref, ["icon", "children", "classNames", "disabled", "selected", "onClick"]);

  var handleClick = function handleClick(event) {
    if (!disabled && onClick) {
      onClick(event);
    }
  }; // ADA compliant - allow an enter key to act like a click.


  var handleKeyPress = function handleKeyPress(target) {
    if (target.key === 'Enter') {
      target.currentTarget.click();
    }
  };

  var additionalProps = disabled ? {} : {
    role: 'button',
    tabIndex: 0,
    onKeyDown: handleKeyPress,
    onClick: handleClick
  };
  var tabNavClassName = (0, _classnames.default)({
    'tabnav-item': true,
    'tabnav-item--disabled': disabled,
    'tabnav-item--selected': selected
  }, classNames);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: tabNavClassName
  }, additionalProps, NewProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "tabnav-item__icon"
  }, icon), /*#__PURE__*/_react.default.createElement("div", {
    className: "tabnav-item__label"
  }, children));
};

exports.TabNavItem = TabNavItem;
TabNavItem.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  selected: _propTypes.default.bool.isRequired,
  icon: _propTypes.default.element,
  children: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func.isRequired
};
var TabNavItemDefaultProps = {
  classNames: '',
  disabled: false,
  selected: false
};
TabNavItem.defaultProps = TabNavItemDefaultProps;

var TabNav = function TabNav(_ref2) {
  var children = _ref2.children,
      classNames = _ref2.classNames,
      icon = _ref2.icon,
      disabled = _ref2.disabled,
      NewProps = _objectWithoutProperties(_ref2, ["children", "classNames", "icon", "disabled"]);

  var TabNavContainerClassName = (0, _classnames.default)('tabnav-container', classNames); // Combine the properties passed to the parent with the child elements.
  // Processing react children is a little weird, see https://reactjs.org/docs/react-api.html#reactchildren for details.

  var newChildren = _react.default.Children.map(children, function (child) {
    if (child.type === TabNavItem) {
      return _react.default.cloneElement(child, {
        icon: typeof child.props.icon !== 'undefined' ? child.props.icon : icon,
        disabled: disabled || child.props.disabled
      });
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  });

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: TabNavContainerClassName
  }, NewProps), newChildren);
};

exports.TabNav = TabNav;
TabNav.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  icon: _propTypes.default.element,
  children: _propTypes.default.node,
  onClick: _propTypes.default.func
};
var TabNavDefaultProps = {
  classNames: '',
  disabled: false
};
TabNav.defaultProps = TabNavDefaultProps;
var _default = TabNav;
exports.default = _default;